function About() {
    return (
        <section id="about" className="about animate__animated">
            <h1>ABOUT US</h1>
            <p>
                Our mission is to exceed client expectations, providing not just tiling services
                but an experience marked by reliability, integrity, and superior workmanship.
                We believe that a beautifully tiled space is a testament to our commitment to quality and aesthetics.
            </p>
        </section>
    );
}

export default About;
